import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DBService } from 'src/app/core/backend-adapter/db.service';
import RZLib from 'src/app/core/backend-adapter/db2/RZ-lib.helpers';
import { IPublish } from '../../review-management.interfaces';
import { ReviewsService } from '../../reviews.service';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
})
export class ConfirmationPopupComponent implements OnInit {
  publishObject: IPublish<any>;
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private dialogService: DialogService,
    private reviewsService: ReviewsService
  ) {}

  ngOnInit(): void {
    this.publishObject = this.dynamicDialogConfig?.data;
  }

  cancelReply() {
    this.ref.close(false);
  }

  /**
   * Confirms and publishes review responses, then opens the success popup.
   * Uses the bulk publish endpoint for multi-select payloads and the single endpoint otherwise.
   * @returns None.
   */
  publishReply(): void {
    this.ref.close(true);

    if (this.publishObject.type == 'multi' || Array.isArray(this.publishObject.data)) {
      const multiReviews = Array.isArray(this.publishObject.data) ? this.publishObject.data : [];
      const publishData = this.publishObject as IPublish<any> & { accountId?: number; loginId?: number };
      const accountId = Number(publishData.accountId ?? multiReviews?.[0]?.account_id);
      const loginId = Number(publishData.loginId ?? multiReviews?.[0]?.loginId);

      this.reviewsService
        .bulkEditReviewNewEndpoint(multiReviews, loginId, accountId, 'google/reviews/response')
        .subscribe();
    } else {
      this.reviewsService
      .bulkEditReviewNewEndpoint([this.publishObject.data], this.publishObject.data.loginId, this.publishObject.data.account_id, 'google/reviews/response')
       // .editReviewNewEndpoint(this.publishObject.data.reviewId, this.publishObject.data.replyComment, this.publishObject.data.loginId, this.publishObject.data.account_id, "google/reviews/response")
        .subscribe();
    }
    
    this.dialogService.open(SuccessPopupComponent, {
      data: { ...this.dynamicDialogConfig?.data },
      closable: false,
      width: '800px',
      height: '300px',
    })
  }
}
